import { render, staticRenderFns } from "./Discounts.vue?vue&type=template&id=71a710f6&lang=pug&"
import script from "./Discounts.vue?vue&type=script&lang=ts&"
export * from "./Discounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports